import { render, staticRenderFns } from "./QuestionOrder.vue?vue&type=template&id=0b27faa3&scoped=true&"
import script from "./QuestionOrder.vue?vue&type=script&lang=js&"
export * from "./QuestionOrder.vue?vue&type=script&lang=js&"
import style0 from "./QuestionOrder.vue?vue&type=style&index=0&id=0b27faa3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b27faa3",
  null
  
)

export default component.exports